<template>
  <div class="page_title">
    <span>{{title}}</span>
    <p v-if="subTitle">{{subTitle}}</p>
  </div>
</template>

<script>
export default {
  name: "pageTitle",
  props: {
    title: {
      type: String,
      default: ""
    },
    subTitle: {
      type: String,
      default: ""
    }
  }
};
</script>
<style scoped lang="scss">
.page_title {
  text-align: center;
  padding-top: 80px;
  padding-bottom: 68px;

  span {
    display: inline-block;
    font-size: 42px;
    font-weight: 500;
    color: #222;
    line-height: 59px;
    position: relative;

    &::before {
      content: '';
      width: 27px;
      height: 18px;
      position: absolute;
      left: -55px;
      top: 50%;
      transform: translateY(-50%);
      background-image: url('../../../img/izixun/title-left-icon.png');
      background-size: 100% 100%;
    }
    &::after {
      content: '';
      width: 27px;
      height: 18px;
      position: absolute;
      right: -55px;
      top: 50%;
      transform: translateY(-50%);
      background: url('../../../img/izixun/title-right-icon.png');
      background-size: 100% 100%;
    }
  }
  p {
    height: 30px;
    font-size: 22px;
    font-weight: 300;
    color: #666;
    line-height: 30px;
    margin-top: 10px;
  }
}
</style>
